const OVERLAY_ID = "search-menu-overlay"

export function createOverlay(onClick?: () => void) {
    if (document.getElementById(OVERLAY_ID)) return

    const overlay = document.createElement("div")
    overlay.id = OVERLAY_ID
    overlay.className =
        "styles_MenuOverlay__TshbT styles_level-1__KQ_gr styles_fadeIn__9jaw5"

    overlay.addEventListener("click", () => {
        onClick?.()
        removeOverlay()
    })

    document.body.appendChild(overlay)
}

export function removeOverlay() {
    const overlay = document.getElementById(OVERLAY_ID)
    if (overlay) overlay.remove()
}
